import { browserUiHeight, gsap, ScrollTrigger } from "../..";

const screen = () => window.innerHeight - browserUiHeight;

const chapter1 = () => {
  const images = document.querySelectorAll("#chapter-1 picture");
  const [a, b1, b2] = Array.from(images);

  gsap.set(a!, { transformOrigin: "bottom right" });

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-1",
      trigger: "#chapter-1",
      start: () => `center ${screen()}`,
      end: () => `center top`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline
    .to(a!, { rotate: -15, y: -10, x: 20 })
    .to(b1!, { rotate: 20, y: 10, x: -20, scale: 0.8 }, "<")
    .to(b2!, { rotate: -5, y: 10, x: -20, scale: 0.8 }, "<");

  return () => {
    timeline.invalidate().kill();
  };
};

const chapter2 = () => {
  const image = document.querySelector("#chapter-2 picture>img")!;

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-2",
      trigger: "#chapter-2",
      start: () => `center ${screen()}`,
      end: () => `center ${screen() / 3}`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline.fromTo(image, { scale: 1.4 }, { scale: 1 });

  return () => {
    timeline.invalidate().kill();
  };
};

const chapter3 = () => {
  const images = document.querySelectorAll("#chapter-3 picture");
  const [a1, a2, b] = Array.from(images);

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-3",
      trigger: "#chapter-3",
      start: () => `center ${screen()}`,
      end: () => `center top`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline
    .to(a1!, { rotate: 2, yPercent: 50 })
    .to(a2!, { rotate: -2, yPercent: 0 }, "<")
    .to(b!, { scale: 1.1 }, "<");

  return () => {
    timeline.invalidate().kill();
  };
};

const chapter4 = () => {
  const images = document.querySelectorAll("#chapter-4 picture");
  const [a1, a2, b] = Array.from(images);

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-4",
      trigger: "#chapter-4",
      start: () => `center ${screen()}`,
      end: () => `center top`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline
    .to(a1!, { rotate: 2, scale: 1.2 })
    .to(a2!, { yPercent: 20 }, "<")
    .to(b!, { scale: 1.1, yPercent: -20 }, "<")
    .fromTo(a1?.querySelector("img")!, { scale: 1.5 }, { scale: 1 }, "<");

  return () => {
    timeline.invalidate().kill();
  };
};

const chapter5 = () => {
  const images = document.querySelectorAll("#chapter-5 picture");
  const [a1, a2, b] = Array.from(images);

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-5",
      trigger: "#chapter-5",
      start: () => `center ${screen()}`,
      end: () => `center top`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline
    .to(a1!, { rotate: 2 })
    .to(a2!, { scale: 0.9, yPercent: 20, rotate: -2 }, "<")
    .to(b!, { xPercent: 10 }, "<");
  // .fromTo(a1?.querySelector("img")!, { scale: 1.5 }, { scale: 1 }, "<");

  return () => {
    timeline.invalidate().kill();
  };
};

const chapter6 = () => {
  const images = document.querySelectorAll("#chapter-6 picture");
  const [a1, a2] = Array.from(images);

  const timeline = gsap.timeline({
    scrollTrigger: {
      id: "chapter-6",
      trigger: "#chapter-6",
      start: () => `center ${screen()}`,
      end: () => `center top`,
      scrub: true,
      markers: false,
      invalidateOnRefresh: true,
    },
  });

  timeline
    .to(a1!, { yPercent: 5, rotate: 2 })
    .to(a2!, { scale: 1, yPercent: -10, rotate: -2 }, "<");
  // .to(b!, { xPercent: 10 }, "<");
  // .fromTo(a1?.querySelector("img")!, { scale: 1.5 }, { scale: 1 }, "<");

  return () => {
    timeline.invalidate().kill();
  };
};

const animate = (_variant: "sm" | "md" | "xl") => {
  const cleanup: Function[] = [];
  cleanup.unshift(chapter1());
  cleanup.unshift(chapter2());
  cleanup.unshift(chapter3());
  cleanup.unshift(chapter4());
  cleanup.unshift(chapter5());
  cleanup.unshift(chapter6());

  return () => cleanup.forEach((c) => c());
};

let mm = gsap.matchMedia();
mm.add("(max-width: 767px)", () => animate("sm"));
mm.add("(min-width: 768px) and (max-width: 1279px)", () => animate("md"));
mm.add("(min-width: 1280px)", () => animate("xl"));
